import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { YesOrNoDialog } from './yes-or-no.module';

@Component({
    selector: 'kt-yes-or-no',
    templateUrl: './yes-or-no.component.html',
    styleUrls: ['./yes-or-no.component.scss'],
})
export class YesOrNoComponent {
    public title: string = '';
    public text: string = '';

    constructor(private dialogRef: MatDialogRef<YesOrNoComponent>, @Inject(MAT_DIALOG_DATA) data: YesOrNoDialog) {
        if (data != null && data != undefined) {
            this.title = data.title;
            this.text = data.text;
        }
    }
}
